import axios from 'axios'

// Пароль проверяет только сервер; здесь лишь храним введённый,
// чтобы слать его в заголовке X-Admin-Auth.
export function isAdmin() {
  return !!localStorage.getItem('adminAuth')
}

// true/false — ответ сервера, null — сервер недоступен
async function checkPassword(password) {
  try {
    await axios.post('/api/admin/login', { password })
    return true
  } catch (error) {
    return error.response?.status === 403 ? false : null
  }
}

export async function login() {
  const password = prompt('Введите пароль для доступа к администрированию:')
  if (password === null) return false
  const ok = await checkPassword(password)
  if (ok) {
    localStorage.setItem('adminAuth', password)
    return true
  }
  alert(ok === false ? 'Неверный пароль!' : 'Сервер недоступен, попробуйте позже')
  return false
}

// Сбрасывает сохранённый пароль, если его сменили на сервере
export async function verifyStoredPassword() {
  const password = localStorage.getItem('adminAuth')
  if (password && (await checkPassword(password)) === false) {
    localStorage.removeItem('adminAuth')
  }
  return isAdmin()
}
